// extracted by mini-css-extract-plugin
module.exports = {"containerInner":"MintStandardPage_containerInner__1jMlN","form":"MintStandardPage_form__2LngM"};